import { render, staticRenderFns } from "./PIDPddTutorial.vue?vue&type=template&id=07d95176&scoped=true"
import script from "./PIDPddTutorial.vue?vue&type=script&lang=js"
export * from "./PIDPddTutorial.vue?vue&type=script&lang=js"
import style0 from "./PIDPddTutorial.vue?vue&type=style&index=0&id=07d95176&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d95176",
  null
  
)

export default component.exports